import TablePagination from './TablePagination';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setDirection, setSortField } from '../../redux/slices/PaginationSlice';
import { isMobile } from 'react-device-detect';
import { MobileTable } from './MobileTable';
import { DesktopTable } from './DesktopTable';

const TableComponent = ({
                            model,
                            translationsGroup,
                            totalElements,
                            columnsNames,
                            contents = [model],
                            buttons
                        }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const pagination = useSelector((state) => state.pagination);

    const sortTableBy = (fieldName) => {
        if (pagination.sortByField === fieldName) {
            if (pagination.sortingDirection === 'ASC') {
                dispatch(setDirection('DESC'));
            } else {
                dispatch(setDirection('ASC'));
            }
        } else {
            dispatch(setSortField(fieldName));
        }
    };

    return (
        <div className={'table-container'}>
            {isMobile
                ? <MobileTable translationsGroup={translationsGroup}
                               columnsNames={columnsNames}
                               items={contents}
                               buttons={buttons}>
                </MobileTable>
                : <DesktopTable sortTableBy={sortTableBy}
                                translationsGroup={translationsGroup}
                                columnsNames={columnsNames}
                                items={contents}
                                buttons={buttons}>
                </DesktopTable>
            }
            <TablePagination totalElements={totalElements} />
        </div>
    );
};

export default TableComponent;
